import Base from './base';

export default class ProductGroups extends Base {
  $relay() {
    return 'product-groups';
  }

  async index(params = {}) {
    return this.$request('get', 'groups', {
      params,
    });
  }

  async create(payload) {
    return this.$request('post', 'groups', payload);
  }

  async read(uuid) {
    return this.$request('get', `groups/${uuid}`);
  }

  async update(uuid, payload) {
    return this.$request('put', `groups/${uuid}`, payload);
  }

  async destroy(uuid) {
    return this.$request('delete', `groups/${uuid}`);
  }

  async getProductGroup(uuid) {
    return this.$request('get', `products/${uuid}`);
  }
}
